module.exports = __webpack_public_path__ + "img/p2-59.6ee4abb7.png";